import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import { LifemapHelpComponent } from './lifemapHelp.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';

@NgModule({
  imports: [CommonModule, SharedModule, NgOptimizedImage, PlIconModule],
  declarations: [LifemapHelpComponent],
  exports: [LifemapHelpComponent],
})
export class LifemapHelpModule {}
